import React from 'react';
import { X } from 'lucide-react';
import useDialog from '../hooks/useDialog';

// Full-screen overlay that shows a single image at large size — used to zoom a profile photo
// so staff can identify the person. Click the backdrop or the X, or press Esc, to close.
// Renders nothing when `src` is falsy, so callers can gate it on a piece of state.
const ImageLightbox = ({ src, alt = '', onClose }) => {
  const lightboxRef = useDialog(onClose, { confirmDiscard: false });

  if (!src) return null;
  return (
    <div
      ref={lightboxRef}
      className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-colors"
        title="Close"
      >
        <X className="h-6 w-6" />
      </button>
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[90vw] max-h-[90vh] rounded-xl object-contain shadow-2xl"
      />
    </div>
  );
};

export default ImageLightbox;
